module.exports = __webpack_public_path__ + "desktop-format-2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-start/assets/desktop-format-2.mp4
// module id = 1166
// module chunks = 10